import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';
import Collapse from 'react-bootstrap/Collapse';

export default function CollapsibleCard(props) {
    const [open, setOpen] = useState(props.isOpen || false);
    const collapseIcon = <i className="fas fa-chevron-up"></i>;
    const expandIcon = <i className="fas fa-chevron-down"></i>;
    const collapseBodyStyle = {
        padding: ".5rem 0 0 0"
    }
    const bodyStyle ={
        padding: "0 1.25rem"
    }
    return (
        <Card className="mb-2 w-100">
            <Card.Header className="font-weight-bold collapse_target"
                    onClick={() => setOpen(!open)}
                    aria-controls={props.ctrlName + "_Body"}
                    aria-expanded={open}
            >
                {props.header}
            </Card.Header>
            <Card.Body style={bodyStyle}>
                <Collapse in={open} style={collapseBodyStyle}>
                    <div id={props.ctrlName + "_Body"}>
                        {props.children}
                    </div>
                </Collapse>
            </Card.Body>
            <div className="text-center collapse_target" 
                onClick={() => setOpen(!open)}
                aria-controls={props.ctrlName + "_Body"}
                aria-expanded={open}
            >
                {open ? collapseIcon : expandIcon}
            </div>
        </Card>
    );
}